<template>
  <div>
    <h3>購入履歴</h3>

    <!-- search filters -->
    <v-card color="grey-lighten-5" class="mt-2" variant="flat">
      <v-container>
        <v-row>
          <v-spacer />
          <v-col cols="3">
            <h5>クラス</h5>
            <v-select
              v-model="searchFilters.classId"
              :items="classes"
              item-title="className"
              item-value="classId"
              variant="outlined"
              density="compact"
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>シリアル番号</h5>
            <v-text-field
              v-model="searchFilters.serialNumber"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>販売種別</h5>
            <v-select
              v-model="searchFilters.mediaFormat"
              :items="mediaFormatType"
              variant="outlined"
              density="compact"
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="3">
            <h5>購入期間開始日</h5>
            <v-text-field
              v-model="searchFilters.from"
              variant="outlined"
              density="compact"
              hide-details
              type="date"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>購入期間終了日</h5>
            <v-text-field
              v-model="searchFilters.to"
              variant="outlined"
              density="compact"
              hide-details
              type="date"
              clearable
            ></v-text-field>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="4">
            <v-btn
              @click="searchHistory"
              :loading="loading"
              color="primary"
              variant="flat"
              block
              class="search-button"
              >{{ $t('memoru.search') }}</v-btn
            >
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-card>

    <!-- history table -->
    <div class="pt-4">
      <v-table>
        <thead>
          <tr>
            <th>ID</th>
            <th>購入日時</th>
            <th>販売種別</th>
            <th>カテゴリ</th>
            <th>撮影日</th>
            <th>単価</th>
            <th>個数</th>
            <th>売上</th>
            <th>クラス</th>
          </tr>
        </thead>
        <tbody v-if="purchaseHistory">
          <tr v-for="(item, i) in purchaseHistory.data" :key="i">
            <td>{{ item.multiMedia.serialNumber }}</td>
            <td>{{ formatDate(item.purchasedAt) }}</td>
            <td>
              {{
                item.mediaFormat
                  ? mediaFormatType.find((m) => m.value == item.mediaFormat)
                      .text
                  : ""
              }}
            </td>
            <td>
              {{
                item.multiMedia.category
                  ? multimediaCategoryType.find(
                      (m) => m.value == item.multiMedia.category
                    ).text
                  : ""
              }}
            </td>
            <td>{{ item.multiMedia.date }}</td>
            <td>{{ `${item.multiMedia.price}円` }}</td>
            <td>{{ `${item.multiMedia.purchasedCount}` }}</td>
            <td>{{ `${item.multiMedia.revenue}円` }}</td>
            <td>
              {{
                item.nurseryClasses
                  ? item.nurseryClasses.map((c) => c.className).join(",")
                  : ""
              }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { multimediaCategoryType, mediaFormatType } from "@/constants/memoru";
import { memoruModule } from "@/store/dataModules/memoruModule";
import LocalDataService from "@/service/LocalDataService";
import {
  MemoruPurchaseHistoryListResponse,
  NurseryClassResponse,
} from "chaild-api/lib";
import dayjs from "dayjs";
import { classModule } from "@/store/dataModules/classModule";

export default defineComponent({
  name: "MemoruPurchaseHistory",

  async mounted() {
    await this.searchHistory();
  },

  data() {
    return {
      loading: false,
      multimediaCategoryType: multimediaCategoryType,
      mediaFormatType: mediaFormatType,
      searchFilters: {
        classId: "",
        from: "",
        to: "",
        mediaFormat: "",
        serialNumber: "",
      },
    };
  },

  computed: {
    purchaseHistory: function (): MemoruPurchaseHistoryListResponse | null {
      return memoruModule.purchaseHistory;
    },
    classes(): NurseryClassResponse[] {
      return classModule.classes;
    },
  },

  methods: {
    async searchHistory() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await memoruModule
          .searchHistory({
            nurseryId,
            ...this.searchFilters,
          })
          .catch(() => (this.loading = false));
      }
      this.loading = false;
    },
    async listClasses() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId,
        });
      }
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("DD/MM/YYYY");
    },
  },
});
</script>
